import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from "@mui/material";

const RejectionPopup = ({ open, handleClose, handleSubmit }) => {
	const [reasonForRejection, setReasonForRejection] = useState("");

	const handleReasonChange = (event) => {
		setReasonForRejection(event.target.value);
	};

	const handleReject = () => {
		handleSubmit(reasonForRejection);
	};

	return (
		<Dialog open={open} onClose={handleClose}>
			<DialogTitle>Reason for Rejection</DialogTitle>
			<DialogContent>
				<TextField autoFocus margin='dense' label='Reason' fullWidth multiline rows={4} variant='outlined' value={reasonForRejection} onChange={handleReasonChange} />
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				<Button onClick={handleReject} color='error'>
					Reject
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default RejectionPopup;
